export default __webpack_public_path__ + "static/blog-cta-cover-a45136bda077f038d26ec1c222b416b8.jpg";